import styled from "styled-components";

const TimerContainerLanding = styled.section`
  padding-left: 30px;
  padding-right: 30px;
  z-index: 1000;
  overflow: hidden;
  background: linear-gradient(275.4deg, #074199 45.31%, #0B6DFF 59.75%);
  position: sticky;
  top: var(--referral-banner-height, 0px);
  justify-content: center;

  border-bottom: 4px solid #0558D4;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  @media (max-width: 768px) {
    background: linear-gradient(355.76deg, #074199 3.91%, #0B6DFF 97.03%);
  }
`;

const Text = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 600;
  font-size: 14px; /* smaller on mobile */
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
  padding: 10px 4px;

  @media (min-width: 768px) {
    padding: 23px 0;
    font-size: 24px;
    line-height: 36px;
  }
`;


const Banner = ({ text }: { text: string }) => {
  
  return (

    <TimerContainerLanding>
      <Text>{text}</Text>
    </TimerContainerLanding>
  );
};

export {
    Banner,
};
